export default [
  {
    path: "/cloudBanking",
    component: () => import(/* webpackChunkName: "cloudBanking" */ "./layout"),
    children: [
      {
        props: true,
        path: ":id/institutions",
        name: "cloudBanking.provider.institutions",
        component: () =>
          import(/* webpackChunkName: "cloudBanking.provider.institutions" */ "./index"),
      },
    ],
  },
];
